<template>
    <div class="map-content">
        <div id="container" class="case-map"></div>
    </div>
</template>

<script>
import MapLoader from "@/libs/AMap.js";
import path from "@/path.js";
export default {
    name: "caseMap",
    data() {
        return {
            oIcon: {
                iconRed: require("@/assets/images/icon_red.png"),
                iconBlue: require("@/assets/images/icon_blue.png"),
                iconYellow: require("@/assets/images/icon_yellow.png"),
            },
            map: null,
            layer: null,
            arrMarkerList: [],
            nActiveIndex: null,
            nName: null,
        };
    },
    props: {
        nLatitude: {
            type: String,
            default: "",
        },
        nLongitude: {
            type: String,
            default: "",
        },
        arrAreaList: {
            type: Array,
            default: () => {
                return [];
            },
        },
    },
    created() {
        // console.log(this.arrAreaList)
        if (this.nLatitude && this.nLongitude) {
            this.initMap();
        }
    },
    mounted() {},
    computed: {},
    watch: {},
    methods: {
        initMap() {
            let that = this;
            MapLoader().then(
                (AMap) => {
                    that.map = new AMap.Map("container", {
                        center: [this.nLongitude, this.nLatitude],
                        zoom: 15,
                        showIndoorMap: false, // 是否在有矢量底图的时候自动展示室内地图，PC默认true,移动端默认false
                        resizeEnable: true, //是否监控地图容器尺寸变化，默认值为false
                        dragEnable: true, // 地图是否可通过鼠标拖拽平移，默认为true
                        keyboardEnable: false, //地图是否可通过键盘控制，默认为true
                        doubleClickZoom: false, // 地图是否可通过双击鼠标放大地图，默认为true
                        zoomEnable: true, //地图是否可缩放，默认值为true
                        rotateEnable: false, // 地图是否可旋转，3D视图默认为true，2D视图默认false
                        expandZoomRange: true,
                    });

                    that.map.on("click", function (e) {
                        var lng = e.lnglat.getLng(); //经度
                        var lat = e.lnglat.getLat(); //维度
                        that.regeoCode(lng, lat);
                    });
                    // 创建标注
                    that.createMarker();
                },
                (e) => {
                    // console.log("地图加载失败", e);
                }
            );
        },
        // 获取当前城市
        regeoCode(lng, lat) {
            let that = this;
            that.map.plugin(["AMap.Geocoder"], function (e) {
                let dateAbress = [lng, lat];
                new AMap.Geocoder().getAddress(
                    dateAbress,
                    function (status, result) {
                        if (status === "complete" && result.regeocode) {
                            var city = result.regeocode.addressComponent.city
                                ? result.regeocode.addressComponent.city
                                : result.regeocode.addressComponent.province;
                            that.$emit("map-change", { lng, lat, city });
                        } else {
                            log.error("根据经纬度查询地址失败");
                        }
                    }
                );
            });
        },

        // 创建标注
        createMarker() {
            // console.log('创建标记点')
            const that = this;
            that.$store.commit("loadSwitch", true);
            const markers = [];
            const zooms = {
                1: [3, 8],
                2: [8, 13],
                3: [13, 18],
                4: [3, 18],
            };
            // 小区位置标注
            // console.log(this.arrAreaList)
            this.arrAreaList.forEach((item, index) => {
                let markerContent =
                    '<div class="ant-map-marker-blue">' +
                    '<div class="text">' +
                    item.total +
                    "</div>" +
                    "</div>";
                let markerOnContent =
                    '<div class="ant-map-marker-yellow">' +
                    '<div class="text">' +
                    item.total +
                    "</div>" +
                    "</div>";
                const marker = new AMap.Marker({
                    zIndex: index + 1,
                    position: new AMap.LngLat(
                        Number(item.longitude),
                        Number(item.latitude)
                    ),
                    content: markerContent,
                    extData: {
                        id: index,
                        name: item.total,
                    },
                    offset: new AMap.Pixel(-13, -30),

                    animation: "AMAP_ANIMATION_DROP", // AMAP_ANIMATION_BOUNCE
                });
                // 绑定点击事件
                marker.on("click", function ({ lat, lng, type, target }) {
                    if (that.nActiveIndex !== null) {
                        that.arrMarkerList[that.nActiveIndex].setContent(
                            '<div class="ant-map-marker-blue">' +
                                '<div class="text">' +
                                that.nName +
                                "</div>" +
                                "</div>"
                        );
                    }
                    // 设置当前标注颜色
                    target.setContent(markerOnContent);
                    // // 记住当前索引
                    that.nActiveIndex = target.getExtData().id;
                    that.nName = target.getExtData().name;
                    // console.log(target.getExtData().id,target.getExtData().name)
                    // 传递参数父组件
                    that.$emit("show-case-list", { ...item });
                });
                markers.push(marker);
                // this.layer.add(labelMarker)
            });
            //自定义聚合的样式
            let _renderMarker = function (context) {
                let content;
                if (context.count >= 10000) {
                    content =
                        '<div class="ant-map-marker-five-big">' +
                        '<div class="text-five-big">' +
                        context.count +
                        "</div>" +
                        "</div>";
                } else if (context.count >= 1000) {
                    content =
                        '<div class="ant-map-marker-four-big">' +
                        '<div class="text-four-big">' +
                        context.count +
                        "</div>" +
                        "</div>";
                } else if (context.count >= 100) {
                    content =
                        '<div class="ant-map-marker-big">' +
                        '<div class="text-big">' +
                        context.count +
                        "</div>" +
                        "</div>";
                } else if (context.count >= 10) {
                    content =
                        '<div class="ant-map-marker-red-sm">' +
                        '<div class="text">' +
                        context.count +
                        "</div>" +
                        "</div>";
                } else if (context.count < 10) {
                    content =
                        '<div class="ant-map-marker-blue">' +
                        '<div class="text">' +
                        context.count +
                        "</div>" +
                        "</div>";
                }
                let offset = new AMap.Pixel(-9, -12);
                context.marker.setContent(content);
                context.marker.setOffset(offset);
            };
            that.map.plugin(["AMap.MarkerClusterer"], function () {
                new AMap.MarkerClusterer(that.map, markers, {
                    minClusterSize: 5,
                    renderClusterMarker: _renderMarker,
                    gridSize: 40,
                });
            });
            // 当前位置标注
            let markerContentNow =
                '<div class="ant-map-marker-yellow">' + "</div>";
            let markerNow = new AMap.Marker({
                position: new AMap.LngLat(
                    this.$route.query.longitude,
                    this.$route.query.latitude
                ),
                content: markerContentNow,
                offset: new AMap.Pixel(-42,-125),
                animation: "AMAP_ANIMATION_DROP", // AMAP_ANIMATION_BOUNCE
            });
            this.map.add(markerNow);
            // 存储Marker数组
            this.arrMarkerList = markers;
            this.map.setFitView();
            that.$store.commit("loadSwitch", false);
        },
    },
    destroyed() {
        this.map && this.map.destroy();
    }
};
</script>

<style lang="scss" scoped>
// @import './index.scss'
.case-map {
    width: 100%;
    height: 100vh;
}
</style>
